import { Box, Card, styled } from '@mui/material';

interface DesktopFrameProps {
  children: React.ReactNode;
}

export const DesktopFrame = ({ children }: DesktopFrameProps) => {
  return (
    <StyledDesktopFrame>
      <BrowserTopBar>
        <ControlButtons>
          {[
            { color: '#ff5f57' }, // close
            { color: '#febc2e' }, // minimize
            { color: '#28c840' }, // maximize
          ].map(({ color }) => (
            <ControlButton
              key={color}
              sx={{
                backgroundColor: color,
              }}
            />
          ))}
        </ControlButtons>
      </BrowserTopBar>
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '4px',
          overflow: 'hidden',
        }}
      >
        {children}
      </Box>
    </StyledDesktopFrame>
  );
};

const StyledDesktopFrame = styled(Card)(({ theme }) => ({
  width: '60%',
  margin: 'auto',
  backgroundColor: theme.palette.grey[800],
  borderRadius: '8px',
  padding: theme.spacing(2),
}));

const BrowserTopBar = styled(Box)(({ theme }) => ({
  height: '28px',
  backgroundColor: theme.palette.grey[700],
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${theme.spacing(2)}`,
}));

const ControlButtons = styled(Box)({
  display: 'flex',
  gap: '4px',
});

const ControlButton = styled(Box)({
  width: 12,
  height: 12,
  borderRadius: '50%',
});
